import fitText from 'fittextjs';
export default (window.fitText = fitText);